import React from 'react';

class LogoutPage extends React.Component {

    // You can add your logout logic here if needed, like clearing user data, tokens, etc.

    render() {
        return (
            <div style={{ textAlign: 'center', marginTop: '20%', fontSize: '24px' }}>
                Logging out...
            </div>
        );
    }
}

export default LogoutPage;
